import axios from 'axios';
import { Toast, Loading } from 'tspuser-toc-vue-modules';
import router from 'pages/router';

const service = axios.create({
  // baseURL: `${process.env.VUE_APP_SOCIALMG}`,
  baseURL: '/api',
  timeout: 12000,
});

service.interceptors.request.use((request) => {
  Loading();
  return request;
}, (error) => Promise.reject(error));
service.interceptors.response.use(
  (response) => {
    Loading.close();

    const errData = response.data.err_resp;

    if (errData && errData.msg && errData.code) {
      errData.reqId = response.data.req_id;
       // 登录失效处理
      if (errData.code === '14101' || errData.code === '14102') {
        // bus.$emit('login');
        console.log('code 14101');
        localStorage.setItem('token', '');
        window.serviceError('14101');
      } else if (errData.msg !== '令牌为空') {
        const { msg } = response.data.err_resp;
        Toast(msg);
        console.log('令牌为空:', msg);
        // router.push('error');
      }
      return Promise.reject(errData);
    }
    return response;
  },
  (error) => {
    Toast('网络不稳定，请检查网络');
    console.log('网络不稳定，请检查网络');
    // router.push('/error');
    Loading.close();
    return Promise.reject(error);
  },
);

/**
 * 封装后的axios方法
 * @param apiUrl 后端给出的api地址
 * @param params = { headers, data, method} 传给后端的参数
 */
export default (apiUrl, params = { headers, data, method }) => {
  console.log(params)
  let data = '';
  if (params.data) {
    data = `?data=${encodeURIComponent(JSON.stringify(params.data))}`;
  }
  return service({
    headers: params.headers,
    url: `${apiUrl}`,
    method: params.method,
    data: params.data
  });
  // return axios({
  //   method: 'post',
  //   baseURL: '',
  //   url: 'http://localhost:3000/api/proxy',
  //   timeout: 10000,
  //   responseType: 'json',
  //   data: {
  //     napiHostname: 'social-qa.saicmg.com',
  //     napiPath: `/api/activity/saicActivity/app/list`,
  //     page: 1,
  //     limit: 10000,
  //     containArticle: 1,
  //     // labelId:10143,
  //     // limit:20,
  //     // findTop:1,
  //     // page:1,
  //     // brandCode:2,
  //   },
  // });

};

